module.exports = __webpack_public_path__ + "static/media/6-50.16e994b4.svg";